<template>
  <div class="book">
    <div class="middle-main">
      <!-- <div @click="openOrder()">
        <column-title title="E-book PERVIEW" desc="我要訂閱" v-if="isPc == 1" />
      </div> -->
      <div :class="['magazine-details', { 'flex-row': isPc == 1 }]">
        <div class="magazine-details-left">
          <div class="magazine-swiper">
            <!-- <swiper :options="swiperOption3" ref="mySwiper">
              <swiper-slide v-for="item in detailsRes.image" :key="item">
                <div class="magazine-item justify-center items-center">
                  <img :src="item" />
                </div>
              </swiper-slide>
            </swiper> -->
            <el-carousel :height="isPc == 1 ? '650px' : '520px'">
              <el-carousel-item v-for="item in detailsRes.image" :key="item">
                <div class="magazine-item ">
                  <img :src="item" />
                </div>
              </el-carousel-item>
            </el-carousel>
            <!-- <div
              class="swiper-button-prev3 items-center justify-center hand"
              v-if="isPc == 1"
            >
              <svg-icon icon-class="Path 707"></svg-icon>
            </div>
            <div
              class="swiper-button-next3 items-center justify-center hand"
              v-if="isPc == 1"
            >
              <svg-icon icon-class="Path 707"></svg-icon>
            </div> -->
          </div>

        </div>
        <div class="magazine-details-right flex-col">
          <h3><em>NO.</em>{{ detailsRes.title }}</h3>
          <p v-html="detailsRes.content"></p>
          <span>{{ L('浏览') }}{{ detailsRes.tips }}</span>
          <div class="line"></div>
          <h5>
            <div>
              <em>HK$</em> {{ detailsRes.price }}
            </div>
            <button class="buy-paper-btn" @click="fnBuyMagazine">
              {{ L('全年訂閱') }}
              <svg-icon icon-class="arrow-right" color="#fff"></svg-icon>
            </button>
          </h5>
          <!-- <p></p> -->
          <div class="line" v-if="isPc == 3"></div>
          <div class="btns" v-if="!isBuy">
            <button v-if="!isInCart" @click="add" class="cart-btn">
              加入購物車
            </button>
            <button v-else @click="fnToCart" class="cart-btn">
              已加購，去購物車結算
            </button>
            <!-- <button @click="fnToBuy" class="buy-pdf-btn">
              購買电子版
              <svg-icon icon-class="pdf2" color="#fff"></svg-icon>
            </button> -->
            <!-- <button @click="fnToPreview">線上預覽</button> -->
          </div>
          <div class="btns" v-else>
            <button class="buy-pdf-btn read-btn" @click="fnToPreview">立即閱讀</button>
          </div>

          <!-- <div class="shopcar-icon">
      <div class="num">3</div>
      <svg-icon class="font22" icon-class="cart-black"></svg-icon>
    </div> -->
          <!-- <button>年度訂閱</button> -->
          <!-- <span>產品編號: <b>00978956</b> </span>
          <span>庫存狀態: <b>尚有庫存</b> </span> -->
        </div>
      </div>
      <div class="line" v-if="isPc != 3"></div>

      <div class="magazine-details-content">
        <!-- <h2>購買須知</h2>
        <div class="content" v-html="purchaseNotes"></div> -->
        <!-- <div class="line" v-if="isPc != 3"></div> -->
        <h2>雜誌簡介</h2>
        <div class="content" v-if="detailsRes.content" v-html="detailsRes.content"></div>
        <div class="content" v-else>{{ L('暂无内容') }}</div>
        <div class="comment-box">
          <div class="line" v-if="isPc != 3"></div>
          <!-- 添加评论 -->
          <Comment :newsId="detailsRes.mgzId" :type="2" />
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import swiperPolicy from "../common/swiper-policy.vue";
import ColumnTitle from "../common/column-title.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Comment from "../common/comment.vue";
import {
  getMagazineDetails,
  createOrder,
  addCart,
  checkInCart,
  checkInOrder,
} from "@/assets/api/magazine.js";
import { getAboutInfo } from "@/assets/api/common.js";

export default {
  components: {
    swiper,
    swiperSlide,
    swiperPolicy,
    ColumnTitle,
    Comment
  },
  data() {
    return {
      swiperOption3: {
        slidesPerView: 1, //一页显示几个
        spaceBetween: 0, //每一个之间的距离
        slidesOffsetBefore: 0, //距离左边的距离
        slidesOffsetAfter: 0, //距离右边的距离
        centeredSlides: true,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 30000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next3", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev3", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled3", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden3", //按钮隐藏时的Class
        },
      },
      activeName: "first",
      detailsRes: {},
      purchaseNotes: "",
      startPoint: {},
      endPoint: {},
      isBuy: false, //是否购买过
      isInCart: false, //是否已经在购物车
      adminList: ['573580143@qq.com', 'fandouhao@gmail.com', 'ts960@vip.163.com'],
    };
  },
  watch: {
    $route() {
      this.$router.go();
    },
  },
  computed: {
    ...mapState(["isPc", "validToken", "userInfo"]),
  },
  created() {
    getMagazineDetails(this.$route.params.id).then((res) => {
      this.detailsRes = res.data.data;
      this.detailsRes.image = this.detailsRes.image.split(",");
      this.detailsRes.image = this.detailsRes.image.map((item) => {
        item = !/^http/.test(item) ? this.$imgUrl + item : item;
        return item;
      });
    });
    getAboutInfo("relatedByBuy").then((res) => {
      this.purchaseNotes = res.data.data.relatedContent;
    });
    checkInCart(this.$route.params.id).then((res) => {
      console.log("查询当前商品是否已加入购物车===", res.data);
      if (res.data.data != null) this.isInCart = true;
    });
    checkInOrder(this.$route.params.id).then((res) => {
      console.log("查询当前商品是否已购买过===", res.data);
      if (this.adminList.includes(this.userInfo.userName)) {
        this.isBuy = true
      } else {
        if (res.data.data != null) {
          this.isBuy = true;
        }
      }
    });
  },
  methods: {
    fnToPreview() {
      // localStorage.setItem('magazineId', this.$route.params.id)
      // this.$router.push({
      //   path: `/magazine-preview`,
      // });
      window.open(this.detailsRes.url, "_blank");
    },
    fnToCart() {
      this.$router.push({
        path: `/magazine-cart`,
      });
    },
    fnToAddCart() {
      addCart(this.$route.params.id).then((res) => {
        if (res.data.code == 500) {
          this.$store.state.isDialogVisible = true;
          console.log("請先登錄");
        } else {
          console.log(res);
        }
      });
    },
    // 加入购物车
    add(e) {
      addCart(this.$route.params.id).then((res) => {
        if (res.data.code == 500) {
          this.$store.state.isDialogVisible = true;
          console.log("請先登錄");
        } else {
          console.log(res);
          this.$message({
            message: "加購成功，請去購物車結算",
            type: "success",
          });
          this.isInCart = true;
          this.$store.dispatch("getMyCart");
          // 特效
          // 页面滚动高度
          // var scrolltopTemp =
          //   document.documentElement.scrollTop || document.body.scrollTop;
          // // 获取起点
          // this.startPoint.x = e.pageX;
          // this.startPoint.y = e.pageY;
          // // 获取终点
          // let target = document.querySelector(".shopcar-icon");
          // let targetParent = target.offsetParent;
          // this.endPoint.y = targetParent.offsetTop + scrolltopTemp + 60;
          // this.endPoint.x = targetParent.offsetLeft + target.offsetWidth / 2;
          // console.log(this.startPoint);
          // console.log(this.endPoint);
          // // 插入div（ball）
          // let ball = document.createElement("div");
          // ball.className = "ball";
          // ball.style.top = this.startPoint.y + "px";
          // ball.style.left = this.startPoint.x + "px";
          // document.body.appendChild(ball);
          // // 添加动画属性
          // setTimeout(() => {
          //   ball.style.top = this.endPoint.y + "px";
          //   ball.style.left = this.endPoint.x + "px";
          // }, 0);
          // // 动画结束后，删除自己
          // ball.ontransitionend = function () {
          //   this.remove();
          // };
        }
      });
    },
    fnToBuy() {
      if (!this.validToken) {
        this.$store.state.isDialogVisible = true;
      } else {
        this.$router.push({
          path: `/magazine-order/${this.$route.params.id}`,
        });
      }

      // createOrder(this.$route.params.id).then((res) => {
      // if (res.data.code == 500) {
      //   console.log("請先登錄");
      // } else {

      // window.open(res.data.data, "_blank");
      // window.open('https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=EC-0WU77850R1826910E', "_blank");

      //   console.log(res);
      // }
      // });
    },
    fnBuyMagazine() {
      this.$router.push({
        path: `/order-single/${this.$route.params.id}`,
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    openOrder() {
      this.$router.push({
        path: `/order`,
      });
    }
  },
};
</script>

<style lang="less" scoped>
.book {
  .magazine-details {
    margin-top: 40px;

    .magazine-details-left {
      width: 500px;

      .magazine-swiper {
        width: 100%;
        position: relative;
      }

      .magazine-item {
        height: 100%;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
          cursor: pointer;
        }
      }

      .content {
        padding: 40px 50px 40px 0;
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.19;
        letter-spacing: 0.8px;
        text-align: left;
        color: #000;
      }
    }

    .magazine-details-right {
      margin-left: 40px;
      flex: 1;
      position: relative;

      h3 {
        em {
          font-size: 10px;
          line-height: 14px;
          font-weight: bold;
        }

        width: fit-content;
        font-family: MicrosoftYaHei,
        MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #E2291E;
        line-height: 21px;
        text-align: left;
        font-style: normal;
        padding-bottom: 4px;
        border-bottom: 4px solid #E2291E;
        margin-bottom: 12px;
      }

      p {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 36px;
        color: #2C2C2E;
        line-height: 47px;
        text-align: left;
        font-style: normal;
      }

      span {
        margin-top: 12px;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        color: #636366;
        line-height: 21px;
        text-align: left;
        font-style: normal;
      }

      h5 {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 32px;
        color: #FF3B30;
        line-height: 26px;
        text-align: left;
        font-style: normal;
        display: flex;
        align-items: center;
        justify-content: space-between;

        em {
          font-size: 20px;
          line-height: 26px;
        }
      }

      .buy-paper-btn {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 21px;
        text-align: center;
        font-style: normal;
        width: 200px;
        height: 50px;
        background: #E2291E;
        border-radius: 25px;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        .svg-icon {
          width: 26px;
          height: 26px;
          margin-left: 10px;
        }
      }

      .btns {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 0;
        left: 0;

        button {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 21px;
          text-align: center;
          font-style: normal;
          padding: 15px 40px;
          border-radius: 25px;
          margin-right: 12px;
          border: none;
          cursor: pointer;
          background: #E2291E;
        }

        .cart-btn {
          background: #FF9500;
        }

        .buy-pdf-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          // padding: 6px 6px 6px 60px;

          .svg-icon {
            width: 89px;
            height: 38px;
            padding: 7px 10px;
            background: #2C2C2E;
            border-radius: 19px;
            margin-left: 40px;
          }
        }
      }
    }
  }

  .line {
    width: 100%;
    height: 1px;
    background: #E5E5EA;
    margin: 40px 0;
  }

  .magazine-details-content {
    margin-bottom: 60px;

    h2 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 24px;
      color: #2C2C2E;
      line-height: 31px;
      text-align: left;
      font-style: normal;
      margin-bottom: 20px;
    }

    .content {
      font-family: MicrosoftYaHei;
      font-size: 20px;
      color: #2C2C2E;
      line-height: 32px;
      text-align: justify;
      font-style: normal;
    }
  }
}

@media screen and (max-width: 768px) {
  .book {
    padding-top: 0;

    .line {
      margin: 30px 0;
    }

    .magazine-details {
      margin-top: 0;

      .magazine-details-left {
        width: 100%;
        padding-top: 0;

        .magazine-swiper {
          width: 100%;
          margin-bottom: 0;
          position: relative;
        }

        .magazine-item {
          img {
            width: 100%;
            height: auto;
            object-fit: cover;
            border-radius: 0;
          }
        }

        .content {
          padding: 40px 50px 40px 0;
          font-family: NotoSansCJKTC;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 2.19;
          letter-spacing: 0.8px;
          text-align: left;
          color: #000;
        }
      }

      .magazine-details-right {
        width: 100%;
        margin-left: 0;
        padding: 20px 20px 40px 20px;

        h3 {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 16px;
          color: #E2291E;
          line-height: 21px;
          text-align: left;
          font-style: normal;
        }

        h5 {
          display: flex;
          // flex-direction: column;
        }

        p {
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 24px;
          color: #2C2C2E;
          line-height: 31px;
          text-align: left;
          font-style: normal;
        }

        .btns {
          position: static;
          bottom: 0;
          left: 0;
          width: 100%;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // padding: 10px 20px;
          z-index: 999;

          button {
            width: 49%;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 21px;
            text-align: center;
            font-style: normal;
            // padding: 14px 20px;
            padding: 0;
          }

          .cart-btn {
            width: 34%;
            height: 50px;
          }

          .buy-pdf-btn {
            width: 62%;
            height: 50px;
            padding: 0;
            margin-right: 0;
            padding-left: 25px;
            padding-right: 6px;
            justify-content: space-between;

            .svg-icon {
              margin-left: 0;
            }
          }

          .read-btn {
            width: 100%;
            justify-content: center;
            padding: 0;
          }
        }

        span {
          font-family: MicrosoftYaHei;
          font-size: 12px;
          color: #636366;
          line-height: 16px;
          text-align: left;
          font-style: normal;

          b {
            color: #000;
          }
        }
      }
    }

    .magazine-details-content {
      h2 {
        border-top: 10px solid #F2F2F7;
        padding: 40px 20px 20px 20px;

      }

      .content {
        padding: 0 20px 40px;
      }
    }
  }

  .comment-box {
    border-top: 10px solid #F2F2F7;
    padding: 0 20px;
  }
}

.other-news {
  padding: 40px 0 80px;
  margin-top: 100px;
}
</style>
<style>
.el-carousel__button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #FFFFFF;
}


.el-tabs__item {
  font-family: NotoSansCJKTC;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: left;
  color: #707070;
  /* padding: 8px 15px!important; */
}

.el-tabs__item:hover {
  color: #e13133;
}

.el-tabs__item.is-active {
  font-family: NotoSansCJKTC;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: left;
  color: #e13133;
}

.el-tabs__active-bar {
  height: 4px;
  background: #e13133;
}

.el-tabs__nav-wrap::after {
  bottom: 2px;
  height: 1px;
  background: #e13133;
}

.magazine-swiper .swiper-slide {
  width: 100% !important;
}

.swiper-button-next3 {
  position: absolute;
  top: 50%;
  left: 0;
  z-index: 9;
}

.swiper-button-next3 .svg-icon,
.swiper-button-prev3 .svg-icon {
  width: 30px;
  height: 30px;
}

.swiper-button-prev3 {
  position: absolute;
  top: 50%;
  right: 0;
  z-index: 9;
  transform: rotate(180deg);
}

/* .shopcar-icon {
  position: absolute;
  top: -30px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0px 0px 8px rgb(184, 184, 184);
  display: flex;
  justify-content: center;
  align-items: center;
} */
.shopcar-icon>.num {
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #fff;
  background: #ffcc33;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 12px;
}

.shopcar-icon>img {
  width: 56px;
  height: 56px;
  vertical-align: middle;
}

.ball {
  position: absolute;
  z-index: 99;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e13133;
  transition: left 0.6s linear, top 0.6s cubic-bezier(0.5, -0.5, 1, 1);
}
</style>



// WEBPACK FOOTER //
// src/views/magazine-details/index.vue